import { css } from 'styled-components';
import { rem } from '../../../helpers/mixins';

export default {
  wrapper: css`
    margin-top: 50px;
    margin-bottom: 30px;
  `,
  title: css`
    font-size: ${rem(24)};
    margin-bottom: 30px;
  `,
  content: css`
    font-size: ${rem(14)};
    line-height: ${rem(22)};
  `,
};
